/**
 * Avisos de cobertura del diagnóstico de batería.
 *
 * Viven fuera del componente para poder probarlos sin montar el gráfico. Cada
 * aviso dice qué parte de los datos falta y qué hacer, sin nombrar clases de
 * Parse: soporte no tiene por qué saber qué es HistoryBattery_V3.
 */

export const formatearFechaCorta = (iso) => {
  if (!iso) return '—';
  const date = new Date(iso);
  return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${date.getFullYear()}`;
};

/**
 * Avisos a mostrar sobre el diagnóstico, del más grave al más leve. Se muestran
 * todos los que apliquen: cada uno describe un problema distinto.
 */
export function avisosDeCobertura(cobertura) {
  if (!cobertura) return [];

  const avisos = [];

  if (cobertura.parcial) {
    avisos.push({
      clave: 'parcial',
      message: 'La lectura de datos se cortó a mitad de camino',
      description:
        'El servidor dejó de responder mientras se leía la telemetría, así que el diagnóstico usa solo las lecturas que alcanzaron a llegar. Vuelve a intentarlo para tener el cuadro completo antes de escalar el caso.',
    });
  }

  if (cobertura.truncado) {
    avisos.push({
      clave: 'truncado',
      message: 'El diagnóstico usa solo parte del historial del reloj',
      description:
        'Este reloj tiene más registros de los que se leen de una vez y pueden faltar los días más recientes. Avisa a desarrollo antes de escalar el caso.',
    });
  }

  return avisos;
}

/**
 * Cuántas lecturas sostienen el diagnóstico y cuántas inválidas se descartaron,
 * en una línea. Los duplicados no se mencionan: son ruido normal del registro.
 * null si no hay cobertura.
 */
export function resumenLecturas(cobertura) {
  if (!cobertura) return null;

  const partes = [`${cobertura.lecturas} lecturas usadas`];

  const invalidas =
    (cobertura.descartadas?.nivelInvalido || 0) + (cobertura.descartadas?.fechaInvalida || 0);
  if (invalidas > 0) {
    partes.push(
      `${invalidas} ${invalidas === 1 ? 'lectura inválida descartada' : 'lecturas inválidas descartadas'}`
    );
  }

  return partes.join(' · ');
}
